import { Dropdown, Flex, MenuProps, message } from 'antd';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { StagesStore } from '../../../../../DataSource/Stores/Cabinet/StagesStore';
import Icon from '../../../../ui/Icon';
import * as styles from './index.module.scss';

dayjs.extend(duration);

interface TimerProps {
  workspaceId?: string;
  jobId?: string;
}

const Timer: React.FC<TimerProps> = ({ workspaceId, jobId }) => {
  const [selectedMinutes, setSelectedMinutes] = useState<number | null>(null);
  const [targetDateTimer, setTargetDateTimer] = useState(
    dayjs(StagesStore?.dataJobs?.job?.expectedDate).valueOf()
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState('загрузка...');

  useEffect(() => {
    if (!StagesStore?.dataJobs?.job?.expectedDate) {
      return StagesStore.setExDate();
    }

    StagesStore.setExDate(StagesStore?.dataJobs?.job?.expectedDate);
  }, [StagesStore?.dataJobs?.job?._id]);

  useEffect(() => {
    const targetDateTimer = dayjs(
      StagesStore.ExDate ? StagesStore.ExDate : StagesStore?.dataJobs?.job?.expectedDate
    ).valueOf();
    setTargetDateTimer(targetDateTimer);
  }, [StagesStore?.dataJobs?.job?.expectedDate, StagesStore.ExDate]);

  useEffect(() => {
    const calculateTimeRemaining = () => {
      const distance = dayjs().diff(StagesStore.ExDate) * -1;

      if (distance < 0) {
        setTimeRemaining('Время вышло!');
      } else {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

        setTimeRemaining(`${days}д ${hours}ч ${minutes}м`);
      }
    };

    const interval = setInterval(calculateTimeRemaining, 1000);

    return () => clearInterval(interval);
  }, [targetDateTimer]);

  const handleAdd = () => {
    if (!selectedMinutes) return;

    const newDate = dayjs(StagesStore.ExDate || StagesStore?.dataJobs?.job?.expectedDate)
      .add(selectedMinutes, 'minute')
      .toDate();

    StagesStore.setExDate(newDate);

    setDropdownOpen(false);
    setSelectedMinutes(null);
    changeExpectedDate();
  };

  const changeExpectedDate = async () => {
    if (!workspaceId || !jobId || !StagesStore.ExDate) return;

    await StagesStore.updateTaskexpectedDate(workspaceId, jobId, StagesStore.ExDate);
    if (StagesStore.taskUpdateDateError) {
      message.error('Ошибка');
    } else {
      message.info('Успешно');
      setSelectedMinutes(null);

      StagesStore.getJobsId(workspaceId, jobId).catch((e) => {
        console.error(e);
      });
    }
  };

  const menu: MenuProps = {
    items: [
      {
        key: '15',
        label: '15 минут',
        onClick: () => setSelectedMinutes(15),
      },
      {
        key: '25',
        label: '25 минут',
        onClick: () => setSelectedMinutes(15),
      },
      {
        key: '45',
        label: '45 минут',
        onClick: () => setSelectedMinutes(45),
      },
      { type: 'divider' },
      {
        key: 'add',
        label: 'Добавить',
        onClick: handleAdd,
      },
    ],
  };

  return (
    <div className={styles.timer}>
      <p className={styles.label}>До завершения осталось:</p>
      <Flex align="center" gap={8}>
        <div className={styles.value}>{timeRemaining}</div>

        <Dropdown menu={menu} trigger={['click']} open={dropdownOpen}>
          <a
            onClick={(e) => {
              e.preventDefault();
              setDropdownOpen((value) => !value);
            }}
          >
            <Icon slug="icons_add_time" />
          </a>
        </Dropdown>
      </Flex>
    </div>
  );
};

export default observer(Timer);
